import { Outlet } from "react-router-dom"

const Layout = () => {
    return (
        <main className="jj">
            <Outlet />
        </main>
    )
}

export default Layout
